import { LineChart } from '@/components/charts/LineChart';
import type { ProgressionDataPoint } from '@/sections/customerManagement/types';

interface Props {
  data: ProgressionDataPoint[];
}

export function ScoreProgressionChart({ data }: Props) {
  if (data.length === 0) {
    return (
      <div className="flex h-48 items-center justify-center">
        <p className="text-chariot-text-secondary text-sm">
          No progression data available.
        </p>
      </div>
    );
  }

  const chartData = data.map(d => ({
    name: d.date.slice(5),
    Score: d.totalScore,
  }));

  return (
    <div className="h-64">
      <LineChart
        type="monotone"
        data={chartData}
        dot
        lines={[
          {
            dataKey: 'Score',
            lineClassName: 'stroke-chariot-brand-primary',
            dotClassName: 'fill-chariot-brand-primary',
            stroke: 'var(--chariot-brand-primary)',
          },
        ]}
      />
    </div>
  );
}
